import styles from "../products/analytics-table.module.css"

export default function VipInsights({ data }) {
    if (!data) {
        return (
            <div className={styles.tableContainer}>
                <h2>VIP Insights</h2>
                <p style={{ color: "rgba(255, 255, 255, 0.6)" }}>No insights data available</p>
            </div>
        )
    }

    return (
        <div className={styles.tableContainer}>
            <h2>VIP Insights</h2>
            <div className={styles.roiCard}>
                <h3>VIP User Engagement</h3>
                <p>Avg Orders Per VIP User: {data?.insights.vipUserEngagement.avgOrdersPerVipUser?.toLocaleString()}</p>
                <p>Avg Spending Per VIP User: ₹{data?.insights.vipUserEngagement.avgSpendingPerVipUser?.toLocaleString()}</p>
            </div>

            <div className={styles.roiCard}>
                <h3>VIP Impact</h3>
                <p>Order Value Increase: {data?.insights.vipImpact.orderValueIncrease?.toLocaleString()}</p>
                <p>Revenue Share: ₹{data?.insights.vipImpact.revenueShare?.toLocaleString()}</p>
            </div>

            <div className={styles.roiCard}>
                <h3>VIP ROI Analysis</h3>
                <p>Total VIP Revenue: ₹{data?.roiAnalysis.totalVipRevenue.toLocaleString()}</p>
                <p>Total Order Revenue: ₹{data?.roiAnalysis.totalOrderRevenue.toLocaleString()}</p>
                <p>Total VIP Users: {data?.roiAnalysis.totalVipUsers.toLocaleString()}</p>
                <p>Total Discounts Given: {data?.roiAnalysis.totalDiscountsGiven.toLocaleString()}</p>
                <p>Net VIP Revenue: {data?.roiAnalysis.netVipRevenue.toLocaleString()}</p>
                <p className={styles.success}>ROI: {data?.roiAnalysis.roiPercentage.toFixed(2)}%</p>
            </div>
        </div>



    )
}
